export interface Distributor {
  id: string;
  name: string;
  region: string;
  territories?: string;
  address: string;
  phone: string;
  email: string;
  website?: string;
  mapX: number;
  mapY: number;
}

export const distributors: Distributor[] = [
  {
    id: "citymind",
    name: "CityMind Technology Group",
    region: "America",
    territories: "Florida",
    address: "10709 Old Grove Cir., Bradenton, FL 34212",
    phone: "941-284-1183",
    email: "lamar@citymind.com",
    website: "https://citymind.com",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "quest-marketing",
    name: "Quest Marketing",
    region: "America",
    territories: "North Carolina, South Carolina, Georgia, Tennessee, Alabama, Mississippi",
    address: "P.O. Box 398625 Miami Beach, Florida 33239",
    phone: "305-993-1213",
    email: "info@questmktg.com",
    website: "https://questmktg.com/",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "bulldog-av",
    name: "Bulldog Audiovisual Sales",
    region: "America",
    territories: "Colorado, New Mexico, Wyoming, Utah",
    address: "1615 39th Street Court, Evans, CO 80620",
    phone: "(970) 888-3755",
    email: "info@bulldogav.com",
    website: "https://www.bulldogav.com",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "iconic-solutions",
    name: "iConic Solutions Group",
    region: "America",
    territories: "Missouri, Iowa, Nebraska, Kansas, Minnesota, North Dakota, South Dakota",
    address: "855 3rd Street SW #4, New Brighton, MN 55112",
    phone: "651-528-6378 / 612-751-9875",
    email: "info@iconicreps.com",
    website: "https://www.iconicreps.com",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "backbeat-marketing",
    name: "Backbeat Marketing",
    region: "America",
    territories: "Michigan, Illinois, Wisconsin",
    address: "19010 W Main St, Lannon, WI 53046",
    phone: "262-404-8642",
    email: "james@backbeat.marketing",
    website: "https://backbeat.marketing/",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "reflex-marketing",
    name: "Reflex Marketing",
    region: "America",
    territories: "South New Jersey, Eastern PA, Connecticut, Rhode Island, Massachusetts, New Hampshire, Vermont, Maine",
    address: "PO Box 94, Red Hill, PA 18076",
    phone: "844-REPFIRM",
    email: "doug@reflexreps.com",
    website: "https://www.reflexmarketing.com",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "synigize-sales",
    name: "Synigize Sales",
    region: "America",
    territories: "Washington DC, Maryland, Virginia, Delaware",
    address: "8588 Richmond Highway #90041, Alexandria, VA 22309",
    phone: "(571) 969-6918 / (202) 277-9394",
    email: "patty@synigize.com",
    website: "https://www.synigize.com",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "audio-source",
    name: "Audio Source, Inc",
    region: "America",
    territories: "Washington, Montana, Oregon, Idaho, Northern California, Alaska, Hawaii",
    address: "601 S Pioneer Way Suite F #285, Moses Lake, WA 98837",
    phone: "425-802-4379",
    email: "info@audiosource.org",
    website: "https://www.audiosource.org",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "cowser-marketing",
    name: "Cowser Marketing",
    region: "America",
    territories: "Texas, Louisiana, Oklahoma, Arkansas",
    address: "1514 Rossport Bend, Leander, TX 78641",
    phone: "(800) 572-6433",
    email: "sales@cowsermarketing.com",
    website: "https://cowsermarketing.com/",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "robert-louis",
    name: "Robert Louis Associates",
    region: "America",
    territories: "Ohio, Indiana, Kentucky, Western Pennsylvania, West Virginia",
    address: "3358 Babcock Blvd, Pittsburgh, PA 15237",
    phone: "(412) 369-8632",
    email: "info@4rla.com",
    website: "https://4rla.com",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "quantum-sales",
    name: "Quantum Sales & Technology, Inc.",
    region: "America",
    territories: "Southern California, Nevada, Arizona, Hawaii",
    address: "",
    phone: "(714) 850-9210",
    email: "",
    website: "https://www.quantumst.com",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "ute-electronic",
    name: "U.T.E. Electronic GmbH & Co. KG",
    region: "Europe",
    territories: "Germany, Austria, Switzerland",
    address: "Friedrich-Ebert-Str. 86, 58454 Witten, Germany",
    phone: "+49 (0) 2302 28 28 3 - 0",
    email: "info@ute.de",
    website: "https://ute.de",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "avhub",
    name: "AvHub",
    region: "Europe",
    territories: "Poland, France, Hungary, Ukraine, Czech Republic, Romania, Bulgaria, Albania, Moldova, Armenia, Georgia, Azerbaijan, Kazakhstan, Uzbekistan",
    address: "Jagiellońska 78, 03-301, Warsaw, Poland",
    phone: "",
    email: "contact@avhub.eu",
    website: "https://avhub.eu/",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "avx-finland",
    name: "AVX Finland Oy",
    region: "Europe",
    territories: "Finland",
    address: "Rälssintie 6, 00720 Helsinki, Finland",
    phone: "+358 40 5708560",
    email: "info@avmfinland.fi",
    website: "https://avmfinland.fi",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "mentor-distribution",
    name: "Mentor Distribution Ltd",
    region: "Europe",
    territories: "United Kingdom",
    address: "23 Henlow Camp Trading Estate, Henlow Camp, Bedfordshire, SG16 6DS, United Kingdom",
    phone: "+44 1462 814 000",
    email: "sales@mentor-distribution.co.uk",
    website: "https://mentor-distribution.co.uk",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "imaginart",
    name: "ImagineArt",
    region: "Europe",
    territories: "Spain, Portugal",
    address: "Pujades 273-275, 08005 Barcelona, Spain",
    phone: "+34 93 292 07 70",
    email: "imaginart@imaginart.es",
    website: "https://www.imaginart.es/",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "sync-av",
    name: "Sync AV",
    region: "Europe",
    territories: "Slovenia",
    address: "Celovska cesta 172, 1000 Ljubljana, Slovenia",
    phone: "+386 (0)1 620 77 25",
    email: "info@sync-av.com",
    website: "https://sync-av.com",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "proaudio-avt",
    name: "ProAudio - AVT",
    region: "Europe",
    territories: "Poland (Warsaw, Krakow, Gdynia)",
    address: "Street Graniczna 89a, 54-530 Wrocław, Poland",
    phone: "+48.717.242.510",
    email: "commercial@proaudio.pl",
    website: "https://proaudio.pl",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "fairlight",
    name: "FAIRLIGHT",
    region: "Europe",
    territories: "Belgium, Netherlands, Luxembourg",
    address: "The Casemates 19, 6681CS Bemmel, Netherlands",
    phone: "+31 (0) 263255880",
    email: "info@fairlight.nl",
    website: "https://www.fairlight.nl",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "leading-technologies",
    name: "Leading Technologies",
    region: "Europe",
    territories: "Italy",
    address: "Via Solferino 54 – 20900 Monza (MB), Italy",
    phone: "+39 039 94-15-204",
    email: "nfo@leadingtech.it",
    website: "https://www.leadingtech.it",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "scandec",
    name: "Scandec Systemer AS",
    region: "Europe",
    territories: "Norway, Sweden",
    address: "Trollaasveien 6, 1414 Trollaasen, Norway",
    phone: "(+47) 66-81-27-00",
    email: "post@scandec.no",
    website: "https://www.scandec.no",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "digitaldomotic",
    name: "Digitaldomotic Sagl",
    region: "Europe",
    territories: "Switzerland",
    address: "In Busciurina 1B, P.O. Box 128, 6528 Camorino, Switzerland",
    phone: "(+41) 79 214 61 72 / (+41) 79 214 70 05",
    email: "sales@digitaldomotic.ch",
    website: "https://www.digitaldomotic.ch",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "aptech",
    name: "APTECH",
    region: "Australia",
    territories: "Australia, New Zealand",
    address: "Unit 16, 23 Narabang Way, Belrose NSW 2085, Australia",
    phone: "+61 (0) 2 9452 6001",
    email: "sales@aptech.com.au",
    website: "https://www.aptech.com.au/",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "fibex-av",
    name: "Fibex AV",
    region: "South America",
    territories: "Brazil",
    address: "Rua Claudio Soares, 72, Conjunto 916, Pinheiros, São Paulo-SP, CEP 05422-030, Brasil",
    phone: "+55 11 3039-2800",
    email: "info@fibexav.com",
    website: "https://www.fibexav.com/",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "wecom-brazil",
    name: "Wecom",
    region: "South America",
    territories: "Brazil",
    address: "Ac. ao Corporate Park, 8600 - Sala 7 • Bloco 2 - Santo Antonio de Lisboa, Florianópolis - SC, 88050-001, Brazil",
    phone: "+55 48 3112 6200",
    email: "comercial@wecom.com.br",
    website: "https://wecom.com.br/",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "yamaki",
    name: "Yamaki",
    region: "South America",
    territories: "Colombia",
    address: "Av. Boyacá No 71-73 Bogota, D.C. Colombia",
    phone: "(+57) 1 438 5285",
    email: "info@yamaki.com.co",
    website: "https://www.yamaki.com.co",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "aligned-av",
    name: "Aligned AV Distributors",
    region: "Asia",
    territories: "Vietnam, Cambodia",
    address: "69A1 Tran Ke Xuong, Ward 7, Phu Nhuan District, TP.HCM",
    phone: "+84 028 35512283",
    email: "sale@alignedav.com",
    website: "https://alignedav.com",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "vortech",
    name: "Vortech",
    region: "Asia",
    territories: "Singapore, Myanmar",
    address: "16 Shaw Road, KIN Building, #06-02, Singapore 367954",
    phone: "+65 66318422 / +65 93393820",
    email: "eugeneyuen@vortechcomms.com",
    website: "https://www.vortechcomms.com/",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "tech-top",
    name: "Tech Top",
    region: "Asia",
    territories: "Israel",
    address: "Rehov Dov Hoz 26, Kiryat Ono 5555624, Israel",
    phone: "+972 03-5353762",
    email: "sales@techtop.co.il",
    website: "https://techtop.co.il",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "mindstec-asia",
    name: "Mindstec Asia",
    region: "Asia",
    territories: "Hong Kong, Republic of Korea",
    address: "25/F, Westin Centre, 26 Hung To Road, Kwun Tong Kowloon, Hong Kong",
    phone: "+852 3709 3990",
    email: "info-asia@mindstec.com",
    website: "https://www.mindstec.com",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "vue-av",
    name: "VUE AV",
    region: "Asia",
    territories: "United Arab Emirates",
    address: "PO Box 54721, Office 126, Al Ferdous 4, Al Safa 1, Dubai, UAE",
    phone: "+971 (0) 4342 5443",
    email: "sales@vueav.com",
    website: "https://www.vueav.com",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "arvanics",
    name: "Arvanics",
    region: "Asia",
    territories: "Japan",
    address: "7-9-1-1F, Chuo, Yamato, Kanagawa 242-0021, Japan",
    phone: "+81-46-259-6920",
    email: "info@arvanics.com",
    website: "https://arvanics.com",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "mindstec-china",
    name: "Mindstec Asia (Beijing)",
    region: "Asia",
    territories: "China",
    address: "B1/F Chaoyang Sports Center North Building, Chaoyang Sports Center East Road, Chaoyang District, Beijing 100123, China",
    phone: "+8610 8586 2260",
    email: "info-china@mindstec.com",
    website: "https://www.mindstec.com.cn",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "nteck-systems",
    name: "NTECK SYSTEMS",
    region: "Asia",
    territories: "India",
    address: "#546, Ground Floor, 16B Cross, 1st Main, Pai Layout, Bengaluru, Karnataka - 560016, India",
    phone: "+91 80 3121 0344",
    email: "info@ntecksystems.com",
    website: "https://www.ntecksystems.com",
    mapX: 0,
    mapY: 0,
  },
  {
    id: "orion-av",
    name: "Orion Audio Visual",
    region: "Africa",
    territories: "South Africa",
    address: "Unit 10, Alphen Square North, 16th Road, Randjespark, Midrand, South Africa",
    phone: "+27 11 314 0040",
    email: "sales@orionaudiovisual.co.za",
    website: "https://www.orionaudiovisual.co.za",
    mapX: 0,
    mapY: 0,
  },
];
